import React, { Component } from 'react'
import { toJS } from 'mobx'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import pickBy from 'lodash/pickBy'
import moment from 'moment'
import { reportApi } from '@atheneum/api'
import { exportDialogMessage, downloadFromUrl, tokenStorage } from '@atheneum/api/dist/lib'

import Action from '@components/Action'
import Download from '@components/Icon/Download'
import Add from '@components/Icon/Add'

class Actions extends Component {
  static propTypes = {
    financialRevenueStore: PropTypes.object,
    queueProcessorStore: PropTypes.object,
    modalStore: PropTypes.object
  }

  exportToExcel = reportRoute => {
    const { query } = this.props.financialRevenueStore
    toJS(query)
    const params = queryString.stringify({
      ...pickBy(toJS(query)),
      fromDate: moment(query.fromDate).format('YYYY-MM-DD'),
      toDate: moment(query.toDate).format('YYYY-MM-DD'),
      entryTypes: query.entryTypes.slice().map(entry => entry.value),
      export: true,
      token: tokenStorage.get()
    })

    const exportUrl = `/api/report/${reportRoute}?${params}`
    window.open(exportUrl)
  }

  finRevenueExport = async () => {
    if (this.exportInProgress) return
    const { query } = this.props.financialRevenueStore
    toJS(query)
    const params = {
      ...pickBy(toJS(query)),
      fromDate: moment(query.fromDate).format('YYYY-MM-DD'),
      toDate: moment(query.toDate).format('YYYY-MM-DD'),
      entryTypes: query.entryTypes.slice().map(entry => entry.value)
    }
    const filename = `financial_revenue_report_${moment(query.fromDate).format(
      'YYYY-MM-DD'
    )}-${moment(query.toDate).format('YYYY-MM-DD')}.xlsx`

    const { jobId } = await reportApi.exportFinancialRevenue(params).catch(() =>
      alert('export error')
    )

    this.props.queueProcessorStore.trackJob(jobId, ({ url }) =>
      downloadFromUrl({ url: `${url}?token=${tokenStorage.get()}`, filename })
    )

    this.job = this.props.queueProcessorStore.jobs[jobId]

    if (this.job && this.job.loading) {
      this.exportInProgress = true
      setTimeout(() => {
        this.exportInProgress = false
      }, 1000)
    }

    await exportDialogMessage({ exportType: 'financial revenue report' })
  }

  render () {
    return (
      <ul className='actions right-list'>
        <li
          className='action'
          onClick={() => {
            this.finRevenueExport()
          }}
        >
          <Action>
            <Download />
            <span>Export</span>
          </Action>
        </li>
        <li
          className='action'
          onClick={() => {
            this.exportToExcel('gl-file')
          }}
        >
          <Action>
            <Download />
            <span>Export GL file</span>
          </Action>
        </li>
        <li
          className='action'
          onClick={() => {
            return this.props.modalStore.show({
              type: 'GENERAL_ADJUSTMENT_FORM'
            })
          }}
        >
          <Action>
            <Add />
            <span>Create general adjustment</span>
          </Action>
        </li>
      </ul>
    )
  }
}

export default inject(
  'queueProcessorStore',
  'financialRevenueStore',
  'modalStore'
)(observer(Actions))
